import { render, staticRenderFns } from "./DataTablePaginated.vue?vue&type=template&id=70c9e4fd&scoped=true"
import script from "./DataTablePaginated.vue?vue&type=script&lang=js"
export * from "./DataTablePaginated.vue?vue&type=script&lang=js"
import style0 from "./DataTablePaginated.vue?vue&type=style&index=0&id=70c9e4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9e4fd",
  null
  
)

export default component.exports